import { Injectable } from '@angular/core';
import { API_PATH } from '../../util/constants';
import { Http } from '@angular/http';

@Injectable()
export class GaleriaService {

  private headers: Headers;
  private opcoes;
  private url;

  constructor(private http: Http) {
    this.headers = new Headers({
      "Allow-Control-Allow-Origin": "*",
      "Allow-Control-Allow-Methods": "GET, POST, PUT, DELETE",
      "Content-Type": "application/json"
    });
    this.opcoes = {headers: this.headers}
  }

  listarNoticias(id) {
    this.url = `${API_PATH}/galeria/buscarGaleria/${id}`;
    return this.http.get(this.url, this.opcoes)
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/portal-cmcti/galeria/galeria.service.ts